import type { FC } from 'react';
import {
  IconButton,
  ProductThumbnail,
  SaleTag,
  Text,
  Tooltip
} from '@cencosud-cencommerce/paris-uikit';

import type { CartOutOfStockItem } from '@/modules/cart/domain/CartOutOfStockItem';

interface ProductItemProps {
  product: CartOutOfStockItem;
  onSaveClick: () => void;
  isAnonymousUser: boolean;
}
const ProductItem: FC<ProductItemProps> = ({
  product,
  onSaveClick,
  isAnonymousUser
}) => {
  return (
    <div className="co-flex co-items-center co-justify-between co-px-1.5">
      <div className="co-flex co-gap-2 co-py-3">
        <ProductThumbnail src={product.image} />
        {product?.storeName ? (
          <div>
            <Text variant="body2" weight={600} element="p">
              {product?.name}
            </Text>
            <SaleTag label="Vendido por" storeName={product?.storeName} />
          </div>
        ) : (
          <Text variant="body2" weight={600} element="p">
            {product?.name}
          </Text>
        )}
      </div>
      <div>
        {!isAnonymousUser && (
          <Tooltip content="¿Quieres mover este producto a tus guardados?">
            <IconButton
              className="[&_path]:co-fill-none"
              size="sm"
              icon="save"
              feedback="neutral"
              onClick={onSaveClick}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default ProductItem;
